// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".nav-link{cursor:pointer}\n", "",{"version":3,"sources":["/home/runner/work/frontend-admin/frontend-admin/src/components/Sidebar.vue"],"names":[],"mappings":"AA8FA,UACE,cAAc","file":"Sidebar.vue?vue&type=style&index=0&lang=scss&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.nav-link {\n  cursor:pointer;\n}\n"]}]);
// Exports
module.exports = exports;
